import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=74f61696&scoped=true"
import script from "./Violations.vue?vue&type=script&lang=js"
export * from "./Violations.vue?vue&type=script&lang=js"
import style0 from "./Violations.vue?vue&type=style&index=0&id=74f61696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f61696",
  null
  
)

export default component.exports